// extracted by mini-css-extract-plugin
export var actions = "_2u-0";
export var actionsContainer = "_2u-7";
export var border = "_2u-1";
export var childFullHeight = "_2u-f";
export var collapse = "_2u-2";
export var content = "_2u-a";
export var contentChild = "_2u-e";
export var fullscreen = "_2u-c";
export var hasLeftRadius = "_2u-k";
export var headerContainer = "_2u-3";
export var headerRow = "_2u-5";
export var hidePadding = "_2u-b";
export var navCollapsedGap = "_2u-l";
export var noScrollX = "_2u-m";
export var noScrollY = "_2u-n";
export var noTopPadding = "_2u-i";
export var optOutTopPadding = "_2u-d";
export var pageMain = "_2u-j";
export var pageOuter = "_2u-g";
export var pagePadding = "_2u-8";
export var pageScroll = "_2u-9";
export var profile = "_2u-o";
export var profileContainer = "_2u-p";
export var profileImage = "_2u-q";
export var profileMain = "_2u-r";
export var profileSubtitle = "_2u-t";
export var profileTitle = "_2u-s";
export var showLeftPadding = "_2u-h";
export var tabsPortalSlot = "_2u-6";
export var tabsWrapper = "_2u-4";
export var title = "_2u-u";